import { Link, NavLink, Outlet } from "react-router-dom";

export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b border-stroke/70 backdrop-blur bg-bg/80 sticky top-0 z-30">
        <div className="max-w-5xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="h-8 w-8 rounded-xl bg-gradient-to-br from-primary to-primaryDeep grid place-items-center">
              <span className="font-extrabold text-white">K</span>
            </div>
            <span className="font-extrabold text-lg tracking-tight">
              Kelime Yarışı
            </span>
          </Link>
          <nav className="hidden sm:flex items-center gap-1 text-sm font-semibold">
            <NavTab to="/terms" label="Koşullar" />
            <NavTab to="/privacy" label="Gizlilik" />
            <NavTab to="/support" label="Destek" />
          </nav>
        </div>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="border-t border-stroke/70 mt-16">
        <div className="max-w-5xl mx-auto px-6 py-10 text-sm text-textMuted flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>© {new Date().getFullYear()} Kelime Yarışı · Made in Türkiye 🇹🇷</div>
          <div className="flex items-center gap-4">
            <Link to="/terms" className="hover:text-textPrimary">
              Koşullar
            </Link>
            <Link to="/privacy" className="hover:text-textPrimary">
              Gizlilik
            </Link>
            <Link to="/support" className="hover:text-textPrimary">
              Destek
            </Link>
            <Link to="/delete-account" className="hover:text-textPrimary">
              Hesap Silme
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

function NavTab({ to, label }: { to: string; label: string }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        [
          "px-3 py-2 rounded-xl transition",
          isActive
            ? "text-textPrimary bg-surface"
            : "text-textSecondary hover:text-textPrimary hover:bg-surface/60",
        ].join(" ")
      }
    >
      {label}
    </NavLink>
  );
}
